/**
 * Map Loading Indicator Component
 *
 * Displays loading state for map data
 * following Single Responsibility Principle
 */

import React from 'react';
import {MapViewMode} from '../../../features/dashboard/types/viewMode.types';

export interface MapLoadingIndicatorProps {
  isLoading: boolean;
  viewMode: MapViewMode;
  userBrands?: string[];
  isProvider?: boolean;
  className?: string;
}

export const MapLoadingIndicator: React.FC<MapLoadingIndicatorProps> = ({
  isLoading,
  viewMode,
  userBrands = [],
  isProvider = false,
  className = ''
}) => {
  if (!isLoading) {
    return null;
  }

  const getLoadingMessage = () => {
    if (viewMode === 'both') {
      if (isProvider && userBrands.length > 0) {
        return `جاري تحميل المتاجر والمسوقين (${userBrands.join(', ')})...`;
      }
      return 'جاري تحميل المتاجر والمسوقين...';
    }
    if (viewMode === 'stores') {
      if (isProvider && userBrands.length > 0) {
        return `جاري تحميل المتاجر (${userBrands.join(', ')})...`;
      }
      return 'جاري تحميل المتاجر...';
    }
    return 'جاري تحميل المسوقين...';
  };

  return (
    <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg px-4 py-3 border ${className}`}>
      <div className="flex items-center gap-3 text-sm text-gray-700">
        <div className="w-4 h-4 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
        <span className="font-medium">
          {getLoadingMessage()}
        </span>
      </div>
    </div>
  );
};

export default MapLoadingIndicator;
